import React, { useState, useEffect, useCallback } from 'react';
import '../Recursos/AdminPedidos.css';

const API = 'https://centrocomunicar.com/api-comunicar/endpoints/recursos_paga.php';

/* ── Icons ── */
const IconStar    = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/></svg>);
const IconSearch  = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="2"/><path d="M21 21l-4.35-4.35" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconClose   = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/><line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);
const IconEdit    = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconCheck   = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><polyline points="20 6 9 17 4 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);
const IconRefresh = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M23 4v6h-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M20.49 15a9 9 0 11-2.12-9.36L23 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconSpinner = () => (<span className="apd-spinner"/>);
const IconWarn    = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><line x1="12" y1="9" x2="12" y2="13" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><line x1="12" y1="17" x2="12.01" y2="17" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);

const NIVEL_COLORS = {
  explorador:   { bg:'#f3f8f5', color:'#5a6a63', label:'Explorador'  },
  comunicador:  { bg:'#d1fae5', color:'#065f46', label:'Comunicador' },
  especialista: { bg:'#fef3c7', color:'#92400e', label:'Especialista'},
  experto:      { bg:'#ede9fe', color:'#5b21b6', label:'Experto'     },
};

export default function AdminPuntos() {
  const [usuarios,   setUsuarios]   = useState([]);
  const [loading,    setLoading]    = useState(false);
  const [busqueda,   setBusqueda]   = useState('');
  const [toast,      setToast]      = useState(null);
  const [modalUser,  setModalUser]  = useState(null); // usuario seleccionado para ajuste
  const [historial,  setHistorial]  = useState([]);
  const [loadingHist,setLoadingHist]= useState(false);
  const [ajuste,     setAjuste]     = useState({ tipo:'sumar', puntos:'', motivo:'' });
  const [guardando,  setGuardando]  = useState(false);

  const showToast = (msg, tipo='ok') => {
    setToast({msg,tipo});
    setTimeout(()=>setToast(null), 3500);
  };

  const fetchUsuarios = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch(`${API}?action=admin_puntos`);
      const j = await r.json();
      if (j.success) setUsuarios(j.data || []);
    } catch(e) { showToast('Error cargando datos','error'); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { fetchUsuarios(); }, [fetchUsuarios]);

  /* Filtrar */
  const q = busqueda.toLowerCase();
  const usuariosFiltrados = usuarios.filter(u =>
    !q || u.nombre?.toLowerCase().includes(q) || u.email?.toLowerCase().includes(q)
  );

  /* KPIs */
  const totalPuntos    = usuarios.reduce((a,u) => a + (parseInt(u.puntos_disponibles)||0), 0);
  const porVencer      = usuarios.filter(u => parseInt(u.por_vencer||0) > 0).length;
  const totalUsuarios  = usuarios.length;

  /* Abrir modal y cargar historial */
  const abrirModal = async (usuario) => {
    setModalUser(usuario);
    setAjuste({ tipo:'sumar', puntos:'', motivo:'' });
    setHistorial([]);
    setLoadingHist(true);
    try {
      const r = await fetch(`${API}?action=admin_historial_puntos&email=${encodeURIComponent(usuario.email)}`);
      const j = await r.json();
      if (j.success) setHistorial(j.data || []);
    } catch(e) {}
    finally { setLoadingHist(false); }
  };

  /* Ajuste manual de puntos */
  const aplicarAjuste = async () => {
    if (!ajuste.puntos || parseInt(ajuste.puntos) <= 0) {
      showToast('Ingresa una cantidad válida de puntos', 'error'); return;
    }
    if (!ajuste.motivo.trim()) {
      showToast('Ingresa un motivo para el ajuste', 'error'); return;
    }
    setGuardando(true);
    try {
      const r = await fetch(`${API}?action=ajustar_puntos`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email:  modalUser.email,
          tipo:   ajuste.tipo,
          puntos: parseInt(ajuste.puntos),
          motivo: ajuste.motivo.trim(),
        }),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      showToast('Puntos ajustados correctamente');
      fetchUsuarios();
      abrirModal({ ...modalUser }); // recargar historial
      setAjuste({ tipo:'sumar', puntos:'', motivo:'' });
    } catch(err) { showToast(err.message, 'error'); }
    finally { setGuardando(false); }
  };

  return (
    <div className="apd-page">

      {toast && (
        <div className={`apd-toast apd-toast--${toast.tipo}`}>
          {toast.tipo==='ok' ? <IconCheck/> : <IconClose/>} {toast.msg}
        </div>
      )}

      {/* KPIs */}
      <div className="apd-kpis">
        <div className="apd-kpi">
          <p>Usuarios con puntos</p>
          <strong>{totalUsuarios}</strong>
          <span>En el programa</span>
        </div>
        <div className="apd-kpi apd-kpi--verde">
          <p>Puntos en circulación</p>
          <strong>{totalPuntos.toLocaleString()}</strong>
          <span>= S/. {(totalPuntos/100).toFixed(2)}</span>
        </div>
        <div className="apd-kpi apd-kpi--azul">
          <p>Con puntos por vencer</p>
          <strong>{porVencer}</strong>
          <span>Próximos 30 días</span>
        </div>
      </div>

      {/* Toolbar */}
      <div className="apd-toolbar">
        <div className="apd-search">
          <IconSearch/>
          <input
            type="text"
            placeholder="Buscar por nombre o email…"
            value={busqueda}
            onChange={e => setBusqueda(e.target.value)}
          />
          {busqueda && <button onClick={()=>setBusqueda('')}><IconClose/></button>}
        </div>
        <button className="apd-btn-ghost" onClick={fetchUsuarios}><IconRefresh/></button>
        <span className="apd-count">{usuariosFiltrados.length} usuarios</span>
      </div>

      {/* Tabla */}
      <div className="apd-tabla-wrap">
        <table className="apd-tabla">
          <thead>
            <tr>
              <th>#</th>
              <th>Usuario</th>
              <th>Nivel</th>
              <th>Disponibles</th>
              <th>Totales</th>
              <th>Canjeados</th>
              <th>Por vencer</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="8" className="apd-loading"><IconSpinner/> Cargando…</td></tr>
            ) : usuariosFiltrados.length === 0 ? (
              <tr><td colSpan="8" className="apd-empty">No hay usuarios con puntos</td></tr>
            ) : usuariosFiltrados.map((u, i) => {
              const niv = NIVEL_COLORS[u.nivel] || NIVEL_COLORS.explorador;
              const tieneVencer = parseInt(u.por_vencer||0) > 0;
              return (
                <tr key={u.email} className="apd-tr">
                  <td className="apd-fecha" style={{fontWeight:700}}>{i+1}</td>
                  <td>
                    <div className="apd-cliente">
                      <strong>{u.nombre}</strong>
                      <span>{u.email}</span>
                    </div>
                  </td>
                  <td>
                    <span className="apd-estado" style={{background:niv.bg, color:niv.color}}>
                      {niv.label}
                    </span>
                  </td>
                  <td>
                    <strong style={{color:'#4db88a'}}>
                      {parseInt(u.puntos_disponibles||0).toLocaleString()}
                    </strong>
                  </td>
                  <td className="apd-fecha">{parseInt(u.puntos_totales||0).toLocaleString()}</td>
                  <td className="apd-fecha">{parseInt(u.puntos_canjeados||0).toLocaleString()}</td>
                  <td>
                    {tieneVencer ? (
                      <span style={{display:'flex',alignItems:'center',gap:'.3rem',color:'#92400e',fontWeight:700,fontSize:'.8rem'}}>
                        <IconWarn/> {parseInt(u.por_vencer).toLocaleString()}
                      </span>
                    ) : (
                      <span className="apd-fecha">—</span>
                    )}
                  </td>
                  <td>
                    <button className="apd-icon-btn" onClick={()=>abrirModal(u)} title="Ver y ajustar">
                      <IconEdit/>
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* ══ MODAL AJUSTE ══ */}
      {modalUser && (
        <div className="apd-overlay" onClick={()=>setModalUser(null)}>
          <div className="apd-modal" style={{maxWidth:560}} onClick={e=>e.stopPropagation()}>
            <div className="apd-modal__head">
              <div>
                <h2>{modalUser.nombre}</h2>
                <p>{modalUser.email}</p>
              </div>
              <button className="apd-modal__close" onClick={()=>setModalUser(null)}><IconClose/></button>
            </div>

            <div className="apd-modal__body">

              {/* Saldo actual */}
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:'.8rem',marginBottom:'1.2rem'}}>
                <div style={{background:'#d1fae5',borderRadius:10,padding:'.8rem',textAlign:'center'}}>
                  <div style={{fontSize:'.72rem',color:'#065f46',fontWeight:600,marginBottom:'.2rem'}}>DISPONIBLES</div>
                  <strong style={{fontSize:'1.3rem',color:'#065f46'}}>{parseInt(modalUser.puntos_disponibles||0).toLocaleString()}</strong>
                </div>
                <div style={{background:'#f3f8f5',borderRadius:10,padding:'.8rem',textAlign:'center'}}>
                  <div style={{fontSize:'.72rem',color:'#5a6a63',fontWeight:600,marginBottom:'.2rem'}}>TOTALES</div>
                  <strong style={{fontSize:'1.3rem',color:'#111'}}>{parseInt(modalUser.puntos_totales||0).toLocaleString()}</strong>
                </div>
                <div style={{background:'#fef3c7',borderRadius:10,padding:'.8rem',textAlign:'center'}}>
                  <div style={{fontSize:'.72rem',color:'#92400e',fontWeight:600,marginBottom:'.2rem'}}>POR VENCER</div>
                  <strong style={{fontSize:'1.3rem',color:'#92400e'}}>{parseInt(modalUser.por_vencer||0).toLocaleString()}</strong>
                </div>
              </div>

              {/* Ajuste manual */}
              <div style={{background:'#f9fafb',borderRadius:12,padding:'1rem',marginBottom:'1.2rem',border:'1.5px solid rgba(130,216,179,.2)'}}>
                <p style={{fontSize:'.8rem',fontWeight:700,color:'#111',marginBottom:'.8rem'}}>⚙️ Ajuste manual de puntos</p>
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'.6rem',marginBottom:'.6rem'}}>
                  <div>
                    <label style={{fontSize:'.75rem',fontWeight:600,color:'#5a6a63',display:'block',marginBottom:'.3rem'}}>Operación</label>
                    <select
                      value={ajuste.tipo}
                      onChange={e=>setAjuste(a=>({...a,tipo:e.target.value}))}
                      style={{width:'100%',padding:'.5rem .7rem',borderRadius:8,border:'1.5px solid rgba(130,216,179,.3)',fontFamily:'inherit',fontSize:'.85rem'}}
                    >
                      <option value="sumar">➕ Sumar puntos</option>
                      <option value="restar">➖ Restar puntos</option>
                    </select>
                  </div>
                  <div>
                    <label style={{fontSize:'.75rem',fontWeight:600,color:'#5a6a63',display:'block',marginBottom:'.3rem'}}>Cantidad</label>
                    <input
                      type="number" min="1" placeholder="Ej: 500"
                      value={ajuste.puntos}
                      onChange={e=>setAjuste(a=>({...a,puntos:e.target.value}))}
                      style={{width:'100%',padding:'.5rem .7rem',borderRadius:8,border:'1.5px solid rgba(130,216,179,.3)',fontFamily:'inherit',fontSize:'.85rem'}}
                    />
                  </div>
                </div>
                <div style={{marginBottom:'.6rem'}}>
                  <label style={{fontSize:'.75rem',fontWeight:600,color:'#5a6a63',display:'block',marginBottom:'.3rem'}}>Motivo *</label>
                  <input
                    type="text" placeholder="Ej: Bonificación por evento, corrección de error…"
                    value={ajuste.motivo}
                    onChange={e=>setAjuste(a=>({...a,motivo:e.target.value}))}
                    style={{width:'100%',padding:'.5rem .7rem',borderRadius:8,border:'1.5px solid rgba(130,216,179,.3)',fontFamily:'inherit',fontSize:'.85rem'}}
                  />
                </div>
                <button
                  onClick={aplicarAjuste}
                  disabled={guardando}
                  style={{background:'#111614',color:'#82D8B3',border:'none',borderRadius:100,padding:'.55rem 1.4rem',fontFamily:'inherit',fontWeight:700,fontSize:'.82rem',cursor:'pointer',display:'flex',alignItems:'center',gap:'.4rem'}}
                >
                  {guardando ? <><IconSpinner/> Aplicando…</> : <><IconCheck/> Aplicar ajuste</>}
                </button>
              </div>

              {/* Historial */}
              <p style={{fontSize:'.8rem',fontWeight:700,color:'#111',marginBottom:'.6rem'}}>📋 Historial reciente</p>
              {loadingHist ? (
                <div style={{textAlign:'center',padding:'1rem',color:'#5a6a63',fontSize:'.85rem'}}><IconSpinner/> Cargando…</div>
              ) : historial.length === 0 ? (
                <div style={{textAlign:'center',padding:'1rem',color:'#5a6a63',fontSize:'.85rem'}}>Sin movimientos</div>
              ) : (
                <div style={{maxHeight:200,overflowY:'auto',display:'flex',flexDirection:'column',gap:'.4rem'}}>
                  {historial.map((h,i) => (
                    <div key={i} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'.5rem .7rem',background:'#f9fafb',borderRadius:8,fontSize:'.78rem'}}>
                      <div>
                        <div style={{fontWeight:600,color:'#111'}}>{h.motivo}</div>
                        <div style={{color:'#5a6a63'}}>{new Date(h.created_at).toLocaleDateString('es-PE')}</div>
                      </div>
                      <span style={{
                        fontWeight:700,
                        color: h.tipo==='ganado' ? '#065f46' : h.tipo==='canjeado' ? '#92400e' : '#5b21b6',
                      }}>
                        {h.tipo==='ganado'?'+':''}{h.puntos} pts
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="apd-modal__foot">
              <button className="apd-btn-ghost" onClick={()=>setModalUser(null)}>Cerrar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}